import { z } from 'zod'
import { isInvalidString, REQUIRED_BASIC_MESSAGE } from '../constants/constants'
import {
  RequiredStringSchema,
  YesOrNoSchema,
} from './application-shared.schema'
import { isValidArray } from '@/pages/providers/components/SchoolForm/school-form.utils.ts'

export const TuitionSchema = z
  .object({
    chargeTuition: YesOrNoSchema,
    kindergartenTuition: RequiredStringSchema.optional(),
    elementaryTuition: RequiredStringSchema.optional(),
    middleSchoolTuition: RequiredStringSchema.optional(),
    highSchoolTuition: RequiredStringSchema.optional(),
    variableTuition: z.array(z.string()).optional(), // ya no usamos AtleastOneArraySchema aquí
  })
  .superRefine((data, ctx) => {
    type TuitionKeys = keyof typeof data

    const addFieldError = (
      field: TuitionKeys,
      message = REQUIRED_BASIC_MESSAGE
    ) => {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [field],
        message,
      })
    }

    if (data.chargeTuition === 'Yes') {
      if (isInvalidString(data.kindergartenTuition))
        addFieldError('kindergartenTuition')
      if (isInvalidString(data.elementaryTuition))
        addFieldError('elementaryTuition')
      if (isInvalidString(data.middleSchoolTuition))
        addFieldError('middleSchoolTuition')
      if (isInvalidString(data.highSchoolTuition))
        addFieldError('highSchoolTuition')

      if (!isValidArray(data.variableTuition)) {
        addFieldError(
          'variableTuition',
          'Variable Tuition is required if you charge tuition'
        )
      }
    } else {
      data.kindergartenTuition = '0'
      data.elementaryTuition = '0'
      data.middleSchoolTuition = '0'
      data.highSchoolTuition = '0'
      data.variableTuition = []
    }
  })

export type TuitionValues = z.infer<typeof TuitionSchema>
